/* global rp$, window */
'use strict';

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for Dealer Selection Warning Modal Module
	 * -----------------------------------------
	 * @section dealer_selection_warning_modal_js
	 ********************************************/
	(function DealerSelectionWarningModalModule() {
		let $dealerSelectionWarningModal,
			$warningModalCancelButton,
			$warningModalContinueButton;

		function HandleWarningModalClose(evt) {
			evt.preventDefault();
			$dealerSelectionWarningModal.modal('hide');
		}

		$onReady({
			rp$, window,
			label: 'dealer_selection_warning_modal',
			fn: function () {
				$dealerSelectionWarningModal = rp$(".dealer-selection-warning-modal");
				$warningModalCancelButton = rp$(".cancel-button", $dealerSelectionWarningModal);
				$warningModalCancelButton.on("click", HandleWarningModalClose);
				$warningModalContinueButton = rp$(".continue-button", $dealerSelectionWarningModal);
				$warningModalContinueButton.on("click", HandleWarningModalClose);
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
